<template>
    <section class="order-delivery__tabs">
        <ul class="order-delivery__tab-list">
            <li class="order-delivery__tab-item" v-for="tab of tabs" :class="{ '_active': tab.isActive }"
                @click="selectTab(tab)">
                <button class="order-delivery__tab-item-link"
                        :class="{ 'inactive': !tab.isActive }"
                        :data-link="tab.href" type="button">
                    {{ tab.name }}
                </button>
            </li>
        </ul>
        <div class="order-delivery__content">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: "tabs",
    data() {
        return {
            tabs: [],
            window: {
                width: 0,
            }
        }
    },
    mounted() {
        this.tabs = this.$children;
    },
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.name === selectedTab.name);
                if(tab.isActive) {
                    this.$emit('input', tab.value);
                }
            });
        }
    }
};
</script>
